<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">User Report</h1>
      <breadcrumb name="POINT_USER_REPORT"></breadcrumb>
      <div class="page-header-right">
        Select balance (end of day) date
        <date-picker
          v-model="date"
          type="date"
          value-type="format"
          format="YYYY-MM-DD"
          placeholder="Select date"
        ></date-picker>
      </div>
      <div class="page-header-actions"></div>
    </div>
    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body p-0">
            <vue-good-table
              ref="table"
              mode="remote"
              :rows="list"
              :columns="columns"
              :totalRows="totalRecords"
              :sort-options="sortOption"
              :search-options="searchOption"
              :pagination-options="pagination"
              @on-search="onSearch"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPerPageChange"
            >
              <div slot="table-actions">
                <div class="Excel">
                  <button @click="exportToExcel" class="btn btn-default">
                    <i class="fa fa-file-excel-o"></i>
                    Export to Excel
                  </button>
                </div>
              </div>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import vueGoodTableMixins from "@/mixins/vue-good-table";

import { walletService } from "@/api/client";
import { userReportTableColumns } from "@/views/point/model";

export default {
  name: "UserReport",

  mixins: [vueGoodTableMixins],

  data() {
    return {
      list: [],
      date: moment().format("YYYY-MM-DD"),
      transactions: [],
      columns: userReportTableColumns,
    };
  },

  watch: {
    date() {
      this.onDateChange();
    },

    transactions(v) {
      this.list = v;
    },

    async "$route.query"() {
      await this.fetch();
      this.initialTableState();
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
  },

  methods: {
    getParams() {
      let params = {
        date: this.date,
      };

      const { sortBy, sortDir, perPage, page, searchTerm } = this.$route.query;

      const pageSize = perPage || this.pagination.perPage;

      if (sortBy) {
        params.order_by = sortBy;
      }

      if (sortDir) {
        params.desc = sortDir == "desc" ? 1 : 0;
      }

      if (searchTerm) {
        params.search = searchTerm;
      }

      if (page) {
        params.start = page ? (page - 1) * pageSize : 0;
      }

      params.count = pageSize || 10;

      return params;
    },

    isValidDate() {
      const { date } = this.$route.query;

      if (!date || !moment(date).isValid()) {
        return false;
      }

      return true;
    },

    async fetch() {
      if (!this.isValidDate()) {
        return;
      }

      const params = this.getParams();

      const { data, total_records } = await walletService.getUserReport(params);

      this.transactions = data;
      this.totalRecords = total_records;
    },

    async exportToExcel() {
      try {
        const response = await walletService.downloadUserReport({
          date: this.date,
        });

        const blob = new Blob([response.data], {
          type: "application/vnd.ms-excel",
        });

        let a = document.createElement("a");
        a.href = window.URL.createObjectURL(blob);
        a.download = `user_report_${moment().format("YYYY_MM_DD")}.xlsx`;
        a.click();
      } catch (error) {
        console.log(error);
      }
    },

    onDateChange() {
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, {
            page: 1,
            date: this.date,
          }),
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.page-header-right {
  position: absolute;
  top: 40px;
  bottom: 0;
  right: 30px;
}
.page-header-actions {
  margin-top: 40px;
  position: absolute;
  bottom: 20px;
}
.panel {
  margin-top: 3px;
}
.show_entries {
  margin-top: 20px;
}
.Excel {
  margin: auto 1rem;
}
</style>
